import * as Admin from './Admin';
import * as Context from './Context';
import * as Onboarding from './Onboarding';
import * as Upgrade from './Upgrade';
import {
  useAcceptTerms,
  useAddonCreditsPaymentIntent,
  useCheckout,
  useConversionCheckout,
  useCustomerPortal,
  useInvoices,
  usePaymentMethod,
  usePreviewProrata,
  useProducts,
  useSubscriptions,
} from './Stripe';
import * as Supabase from './Supabase';
import { useConfigs } from './useConfigs';
import { useDownloadHistory } from './useDownloadHistory';
import { useEnv } from './useEnv';
import { useRefreshDownload } from './useRefreshDownload';
import { useFeatures } from './useFeatures';
import { useFeedback } from './useFeedback';
import { useFilters } from './useFilters';
import { useFiltersByGroup } from './useFiltersByGroup';
import { useHomePage } from './useHomePage';
import { useSignals } from './useSignals';
import { useUpdateCountries } from './useUpdateCountries';

export const App = {
  useHomePage,
  useAcceptTerms,
  Context,
  useEnv,
  useFeedback,
  useFilters,
  useFiltersByGroup,
  useProducts,
  useDownloadHistory,
  useRefreshDownload,
  useSubscriptions,
  useCustomerPortal,
  useCheckout,
  useConversionCheckout,
  useInvoices,
  useAddonCreditsPaymentIntent,
  usePaymentMethod,
  Supabase,
  useFeatures,
  useConfigs,
  useSignals,
  usePreviewProrata,
  useUpdateCountries,
  Upgrade,
  Onboarding,
  Admin,
};
